import { Layout, theme, Grid } from "antd";
import React from "react";
import { FooterLayout } from "./shared/components/footer-layout";

const { Header, Content } = Layout;

export interface OnboardingSubPageLayoutProps {
  header: React.JSX.Element;
  children?: React.ReactNode;
}

export const OnboardingSubPageLayout: React.FC<OnboardingSubPageLayoutProps> = (props) => {
  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;

  const {
    token: { colorText },
  } = theme.useToken();
  return (
    <Layout style={{ minHeight: "100vh", width: "100%" }}>
      <Header style={{ padding: 0, height: "fit-content", color: colorText, backgroundColor: "transparent"}}>{props.header}</Header>
      <Content
        style={{
          marginTop: isMobile ? "210px" : "100px",
          padding: isMobile ? "0 16px" : "0 48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {props.children}
      </Content>
      <div style={{ paddingBottom: '20px' }}>
        <FooterLayout mobileStyle={{marginBottom: 40}} desktopStyle={{paddingBottom: 40}}/>
      </div>
    </Layout>
  );
};
